import GamePage from "./Pages/GamePage/GamePage";
import LandingPage from "./Pages/LandingPage/LandingPage";
import "./App.scss";
import { injectSpeedInsights } from "@vercel/speed-insights";
import { useEffect, useRef } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";

// Avoid `@vercel/speed-insights/react` here: CRA can bundle a second `react`, breaking hooks.
function SpeedInsightsRouteSync() {
  const { pathname } = useLocation();
  const setRouteRef = useRef(null);

  useEffect(() => {
    if (!setRouteRef.current) {
      const handle = injectSpeedInsights({
        framework: "react",
        route: pathname,
      });
      if (handle) setRouteRef.current = handle.setRoute;
    } else if (pathname) {
      setRouteRef.current(pathname);
    }
  }, [pathname]);

  return null;
}

function App() {
  return (
    <>
      <BrowserRouter>
        <SpeedInsightsRouteSync />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/play" element={<GamePage />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
